import React, { useMemo } from 'react';
import { ENavigationPath } from 'constants/path';
import HomeLayout from 'layouts/home-layout';
import { useNavigate, useParams } from 'react-router';
import ClaimHeader from 'components/ui/claim-header';
import {
  ClaimResponseDto,
  ClaimResponseDtoStatusEnum,
  MeResponseDtoRoleEnum,
} from 'libs/pinnacle-sdk';
import NavigationTabs from 'routes/Claims/ClaimDetail/navigation-tab';
import {
  getComponentByTabId,
  getClaimConfigTabs,
  NUMBER_OF_CLAIM_HEADER_TABS,
} from './navigation-tab/claim-config-tabs';
import { useTranslation } from 'react-i18next';
import { isNumeric } from 'utils';
import { isNumber } from 'lodash';
import { constructClaimDetailPath } from 'constants/path';
import { EQueryKeys } from 'constants/query-keys';
import { claimsApi } from 'services/apis';
import { useQuery } from 'react-query';
import { EDashboardTab } from 'components/features/dashboard-tabs/types';

const ClaimDetail: React.FC = () => {
  const navigate = useNavigate();
  const { tabId, claimId } = useParams<{
    tabId: string;
    claimId: string;
  }>();
  const { data: claim } = useQuery(
    [EQueryKeys.CLAIM_BY_ID, claimId, tabId],
    () =>
      claimsApi.getClaimById({
        claimId: claimId as string,
        includeClaimHandler: true,
        includeInsured: true,
      }),
    {
      enabled: !!claimId,
      refetchOnWindowFocus: false,
      staleTime: 0,
      cacheTime: 0,
      keepPreviousData: true,
    }
  );
  const activeKey = tabId && isNumeric(tabId) ? Number(tabId) : tabId || 0;
  const { t } = useTranslation();

  const ActiveComponent = useMemo(
    () => getComponentByTabId(activeKey, t),
    [activeKey, t]
  );

  return (
    <HomeLayout
      title="Claim"
      backDestinationPath={ENavigationPath.DASHBOARD}
      backNavigationState={{ activeTab: EDashboardTab.CLAIM }}
    >
      <div className="sticky top-0 z-10 bg-white">
        {claim && <ClaimHeader claim={claim} />}
        <NavigationTabs
          claimId={claimId}
          tabId={tabId}
          claimStatus={claim?.status}
        />
      </div>
      {claim && (
        <div className="my-4 rounded-2xl bg-[#E3F2FB] p-3">
          <ActiveComponent
            claim={claim}
            includeBack={Number(activeKey) > 0}
            includeNext={
              Number(activeKey) < getClaimConfigTabs(undefined, t).length - 1
            }
            navigateBack={(step?: number) =>
              navigate(
                constructClaimDetailPath(
                  claim.claimId,
                  String(
                    (Number(activeKey) -
                      (isNumber(step) ? step : 1) +
                      NUMBER_OF_CLAIM_HEADER_TABS) %
                      NUMBER_OF_CLAIM_HEADER_TABS
                  )
                )
              )
            }
            navigateNext={(step?: number) => {
              return navigate(
                constructClaimDetailPath(
                  claim.claimId,
                  String(
                    (Number(activeKey) + (isNumber(step) ? step : 1)) %
                      NUMBER_OF_CLAIM_HEADER_TABS
                  )
                )
              );
            }}
          />
        </div>
      )}
    </HomeLayout>
  );
};

export default ClaimDetail;
